import {NumberValue, StringValue, TaskVariableValue} from '../types/entities/tasks';
import {formatLatexNumberValue} from './formatLatexNumberValue';

export function formatVariableValue(variableValue: TaskVariableValue): string {
  if (variableValue.valueType === 'NumberValue') {
    return formatLatexNumberValue(variableValue as NumberValue);
  } else if (variableValue.valueType === 'StringValue') {
    return (variableValue as StringValue).value;
  }

  return '<< UNKNOWN VARIABLE VALUE TYPE >>';
}
